// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h-B38","controls":"styles_controls__3OONs","charLimit":"styles_charLimit__2o16_","input":"styles_input__3wYm0","send":"styles_send__2xXI9"};